export default __webpack_public_path__ + "static/media/resnetgru8.e78d3c08.png";